module.exports = __webpack_public_path__ + "img/romantik-guide3.c1192d8c.jpg";